"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 6/17/2017.
 */
var OtherFields = /** @class */ (function () {
    // constructor(origin: string, criticalAssumptionsandInformationGap: string, sourceofVerification: string, UnitofMeasure: number, IsSameAsPlannedDate: number, TransversalThemes: number) {
    //     this.Origin = origin;
    //     this.CriticalAssumptionsandInformationGap = criticalAssumptionsandInformationGap;
    //     this.SourceofVerification = sourceofVerification;
    //     this.UnitofMeasure = UnitofMeasure;
    //     this.IsSameAsPlannedDate = IsSameAsPlannedDate;
    //     this.TransversalThemes = TransversalThemes;
    // }
    function OtherFields(origin, criticalAssumptionsandInformationGap, sourceofVerification, UnitofMeasure, IsSameAsPlannedDate, TransversalThemes, hasOverallBaseline, hasOverallTarget, overallBaseline, overallTarget, overallBaselineDate, overallTargetDate, notes, isActivitySpecific, DGTypeId, IndicatorCode) {
        this.Origin = origin;
        this.CriticalAssumptionsandInformationGap = criticalAssumptionsandInformationGap;
        this.SourceofVerification = sourceofVerification;
        this.UnitofMeasure = UnitofMeasure;
        this.IsSameAsPlannedDate = IsSameAsPlannedDate;
        this.TransversalThemes = TransversalThemes;
        this.HasOverallBaseline = hasOverallBaseline;
        this.HasOverallTarget = hasOverallTarget;
        this.OverallBaseline = overallBaseline;
        this.OverallTarget = overallTarget;
        this.OverallBaselineDate = overallBaselineDate ? new Date(overallBaselineDate) : null;
        this.OverallTargetDate = overallTargetDate ? new Date(overallTargetDate) : null;
        this.Notes = notes;
        this.IsActivitySpecific = isActivitySpecific;
        this.DGTypeId = DGTypeId;
        this.IndicatorCode = IndicatorCode;
    }
    return OtherFields;
}());
exports.OtherFields = OtherFields;
//# sourceMappingURL=other-fields.model.js.map